import { FormInputTextArea } from './component.styles'
export default FormInputTextArea
